<template>
  <div id="question-create-details-tab" @keyup.ctrl.enter="question_update_data">
    <div class="vx-col w-full">
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-6">
          <h2 class="font-light mb-2 ml-1">Question ID</h2>
          <vs-input v-model="dataLocal.id" class="w-full" readonly />
        </div>
        <div class="vx-col w-1/2">
          <h2 class="font-light mb-2 ml-1">Question Type</h2>
          <v-select class="mb-3 w-full" :options="questionTypeOptions" v-model="dataLocal.type" />
        </div>
        <div class="vx-col w-1/2">
          <h2 class="font-light mb-2 ml-1">Question</h2>
          <vs-textarea v-model="dataLocal.question" height="250px" />
        </div>
        <div class="vx-col w-1/2">
          <h2 class="font-light mb-2 ml-1">Explanation Text</h2>
          <vs-textarea v-model="dataLocal.explanationText" height="250px" />
        </div>
        <!-- <div class="vx-col w-1/2 mb-6">
          <h2 class="font-light mb-2 ml-1">Domain ID</h2>
          <vs-input v-model="dataLocal.domainId" class="w-full" />
        </div> -->
        <div class="vx-col w-full mb-6" v-if="dataLocal.meta && dataLocal.meta.prompt">
          <h2 class="font-light mb-2 ml-1">Prompt</h2>
          <vs-input v-model="dataLocal.meta.prompt" class="w-full" />
        </div>
        <div class="vx-col w-full" :key="key">
          <h2 class="font-light mb-2 ml-1">Options & Answers</h2>
          <div v-for="(answer, index) in dataLocal.meta.options" :key="index" class="mb-6">
            <h4 class="font-light mb-2 ml-1">Answer {{ index }}</h4>
            <div class="flex items-center justify-center gap-2">
              <vs-switch v-model="answer.correct" @click="toggle_correct(index)" />
              <vs-input v-model="answer.text" class="w-full" />
              <feather-icon icon="Trash2Icon" svgClasses="h-8 w-8 text-danger cursor-pointer" @click="remove_answer(index)" />
            </div>
          </div>
          <vs-button class="mb-6" @click="add_answer">Add Additional Answer</vs-button>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mb-2 mr-2" color="success" type="filled" @click="question_update_data">Update Question </vs-button>
          <vs-button class="mb-2 ml-2" color="warning" type="border" @click="reset_data">Reset </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      question_description_counter: null,
      key: 0,

      statusOptions: ['active', 'hidden', 'disabled'],
      questionTypeOptions: ['multiple_choice', 'select_choice'],
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    vSelect,
  },
  methods: {
    init() {
      if (this.dataLocal.meta && this.dataLocal.meta.options) {
        this.dataLocal.meta.options.forEach((item, index) => {
          const answer = this.dataLocal.meta.answers.find((o) => o.text === item.text);
          this.dataLocal.meta.options[index].correct = answer ? answer.correct : false;
        });
        this.key++;
      }
    },
    add_answer() {
      this.dataLocal.meta.options.push({
        text: '',
        icon: 'default',
      });
    },
    remove_answer(index) {
      this.dataLocal.meta.options.splice(index, 1);
    },
    toggle_correct(index) {
      this.dataLocal.meta.options[index].correct = !this.dataLocal.meta.options[index].correct;
      this.key++;
    },
    question_update_data() {
      this.dataLocal.meta.answers = this.dataLocal.meta.options
        .filter((option) => option.correct === true)
        .map((option) => ({
          text: option.text,
          correct: true,
        }));

      // Remove the correct property from all options
      this.dataLocal.meta.options.forEach((option) => {
        delete option.correct;
      });

      this.$emit('updateQuestionData', this.dataLocal);
    },
    reset_data() {
      this.dataLocal = JSON.parse(JSON.stringify(this.data));
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped></style>
